import { createSlice } from "@reduxjs/toolkit";
import getInvestigationApi from "@custom/rtk-apis/billing/getInvestigation";

interface PackageItem {
  _id: string;
  _rev: string;
  type: string;
  packageName: string;
  servicesIncluded: string[];
  packagePricing: string;
  hospitalId: string;
  createdAt: string;
}

interface PackageResponse {
  status: string;
  data: PackageItem[];
}

interface PackageState {
  status: string;
  result: PackageResponse | null;
  loading: boolean;
  error: string;
}

const initialState: PackageState = {
  status: "",
  result: null,
  loading: false,
  error: ""
};

const getInvestigationSlice = createSlice({
  name: "getInvestigationSlice",
  initialState,
  reducers: {
    closeModal(state) { state.status = ""; }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getInvestigationApi.pending, (state) => {
        state.loading = true;
        state.status = 'pending';
      })
      .addCase(getInvestigationApi.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.status = payload.status;
        state.result = payload;
      })
      .addCase(getInvestigationApi.rejected, (state, action) => {
        state.result = null;
        state.loading = false;
        state.status = 'failed';
        state.error = action.error?.message || "Failed to fetch package data";
      });
  },
});

export default getInvestigationSlice.reducer;
export const { closeModal } = getInvestigationSlice.actions;
